import { useQuery } from "@tanstack/react-query";
import { Phone, MessageCircle } from "lucide-react";
import api from "@/lib/api";

export default function CustomersAdmin() {
  const { data: customers = [], isLoading } = useQuery({ queryKey: ["admin-customers"], queryFn: () => api.get("/admin/customers").then((r) => r.data) });
  return (
    <div data-testid="admin-customers">
      <h1 className="text-2xl font-heading font-bold text-navy-heading mb-1">Customers</h1>
      <p className="text-slate-500 text-sm mb-6">Customers derived from booking enquiries, grouped by phone number.</p>
      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-500 text-left">
            <tr><th className="px-4 py-3 font-medium">Name</th><th className="px-4 py-3 font-medium">Phone</th><th className="px-4 py-3 font-medium">Bookings</th><th className="px-4 py-3 font-medium">Recent Trips</th></tr>
          </thead>
          <tbody>
            {isLoading ? <tr><td colSpan={4} className="p-10 text-center text-slate-400">Loading…</td></tr> :
              customers.length === 0 ? <tr><td colSpan={4} className="p-10 text-center text-slate-400">No customers yet.</td></tr> :
              customers.map((c, i) => (
                <tr key={i} className="border-t border-slate-100 align-top">
                  <td className="px-4 py-3 font-medium text-navy-heading">{c.name}</td>
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-2 text-slate-600">
                      <a href={`tel:${c.phone}`} className="flex items-center gap-1 hover:text-brand"><Phone className="w-3.5 h-3.5" /> {c.phone}</a>
                      <a href={`https://wa.me/91${(c.phone||"").replace(/\D/g,'').slice(-10)}`} target="_blank" rel="noreferrer" className="text-whatsapp"><MessageCircle className="w-4 h-4" /></a>
                    </div>
                  </td>
                  <td className="px-4 py-3"><span className="bg-brand-light text-brand font-semibold px-2.5 py-1 rounded-full text-xs">{c.bookings}</span></td>
                  <td className="px-4 py-3 text-slate-500 text-xs">
                    {(c.history || []).slice(0, 3).map((h, j) => <div key={j}>{h.trip_type}: {h.pickup_location || "—"} → {h.drop_location || "—"} ({h.status})</div>)}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
